import ChatView from './chat-view.vue'
export default ChatView